"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledUpsellBanner = void 0;
var _UpsellBanner = require("./UpsellBanner");
// TODO: in v9, move styled() from UpsellBanner.jsx to here
var StyledUpsellBanner = _UpsellBanner.UpsellBanner;
exports.StyledUpsellBanner = StyledUpsellBanner;